// @ts-strict-ignore
/** @jsx jsx */
import React, { useState } from 'react'
import { jsx, Themed, useThemeUI } from 'theme-ui'
import { connect } from 'react-redux'
import Breadcrumbs from './breadcrumbs.connected'
import { getModuleFromIncludes, includes } from '../redux/contentful-selectors'
import { contentId } from '../utils/contentful'
import ImgixImg from './helpers/imgix-image'
import { Col, Row, Container as DefaultContainer } from './helpers/react'
import { DynamicSparkIcon } from './helpers/dynamic-spark-icon'

const CategoryHeadingModule = ({
  title,
  text,
  breadcrumbs: Breadcrumbs,
  image,
  className,
  hideDescriptionMobile = false,
  icon,
  iconColor = '',
  ...rest
}) => {
  const lgContentSpan = 6
  const smContentSpan = 12

  const Container = rest.container || DefaultContainer

  const { theme } = useThemeUI()
  const breadcrumbsVariant = theme.elements?.category?.breadcrumbs?.variant
  const contentSpan = theme.elements?.category?.contentSpan || smContentSpan
  const [showDescription, setShowDescription] = useState(hideDescriptionMobile)
  return (
    <div
      sx={{
        paddingX: ['sm', 'md'],
        paddingBottom: ['md', 'lg'],
        paddingTop: Breadcrumbs ? ['xs', 'sm'] : ['md', 'lg'],
        variant: 'elements.category.main',
      }}
      className={className}
    >
      <Container
        sx={{
          variant: 'elements.category.container',
        }}
      >
        <If condition={Breadcrumbs || icon}>
          <div
            sx={{
              marginBottom: 'sm',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <If condition={Breadcrumbs}>
              <Breadcrumbs.type {...Breadcrumbs.props} variant={breadcrumbsVariant} />
            </If>
            <If condition={icon && hideDescriptionMobile}>
              {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/interactive-supports-focus */}
              <div
                role='button'
                sx={{ display: ['block', 'none'] }}
                onClick={() => setShowDescription(!showDescription)}
              >
                <DynamicSparkIcon glyph={icon} color={iconColor} size={25} />
              </div>
            </If>
          </div>
        </If>
        <Row>
          <Col span={contentSpan} sx={{ marginBottom: [0, 0] }}>
            <Themed.h1
              sx={{
                padding: 0,
                margin: 0,
                variant: 'elements.category.heading',
              }}
            >
              {title}
            </Themed.h1>
            <If condition={text}>
              <Themed.p
                sx={{
                  marginBottom: 0,
                  variant: 'elements.category.text',
                  maxHeight: showDescription ? ['0', '500px'] : '500px',
                  transition: 'max-height 400ms ease-in-out 0ms',
                  overflow: 'hidden',
                }}
              >
                {text}
              </Themed.p>
            </If>
          </Col>
          <If condition={image}>
            <Col
              span={[smContentSpan, lgContentSpan]}
              sx={{
                marginTop: ['sm', 0],
                maxHeight: showDescription ? ['0', '500px'] : '500px',
                transition: 'max-height 400ms ease-in-out 0ms',
                overflow: 'hidden',
              }}
            >
              {image}
            </Col>
          </If>
        </Row>
      </Container>
    </div>
  )
}

const Figure = (props) => {
  const breadcrumbs = props.breadcrumbs && <Breadcrumbs entity={props.breadcrumbs} />
  const Image = props.image && (
    <ImgixImg
      src={props.image?.file?.url}
      alt={props.image?.title}
      sx={{
        maxHeight: '180px',
        display: 'block',
        marginLeft: 'auto',
        marginRight: ['auto', 0],
      }}
    />
  )

  return (
    <CategoryHeadingModule
      {...props}
      breadcrumbs={breadcrumbs}
      image={Image}
      icon='info'
      iconColor='opaque-white-01'
    />
  )
}

export default connect((state, props) => {
  const image = getModuleFromIncludes(includes(state), contentId(props.image)).fields
  return { image }
})(Figure)
